import _ from 'lodash';
import { CreativeTemplatesEntities, Views } from '../../../../../constants';
import { CreativeImage, CarouselCreative, CarouselSlide } from '../../../../../types';
import { useCreativeTemplatesBuilderStore } from 'stores/CreativeTemplatesBuilderStore';
import { useMemo } from 'react';

export const useImagesGallery = () => {
  const store = useCreativeTemplatesBuilderStore();

  const isSelected = (image: CreativeImage) => {
    switch (store.view) {
      case Views.ImageOrVideoCreativeTemplateEditor:
        const images = store.imageOrVideoCreativeTemplateInputs[CreativeTemplatesEntities.IMAGES];
        return _.some(images, { id: image.id, type: image.type });
      case Views.CarouselCreativeTemplateEditor:
        const allImages = _.reduce(store.carousels, carouselsReducer, [] as CreativeImage[]);
        return _.some(_.uniqBy(allImages, 'id'), { id: image.id, type: image.type });
      default:
        return false;
    }
  };

  const handleImageSelect = (image: CreativeImage, checked: boolean) => {
    if (store.view === Views.CarouselCreativeTemplateEditor) {
      const updatedCarousels = _.map(store.carousels, (carousel) => mapCarousels(carousel, image));
      store.setCarousels(updatedCarousels as CarouselCreative[]);
    }

    if (store.view === Views.ImageOrVideoCreativeTemplateEditor) {
      store.selectImage(image, checked);
    }
  };

  const mapCarousels = (carousel: CarouselCreative, image: CreativeImage) => {
    const updatedSlides = _.map(carousel.carouselAssetSpecs, (slide) => mapSlides(slide, image));
    return { ...carousel, carouselAssetSpecs: updatedSlides };
  };

  const mapSlides = (slide: CarouselSlide, image: CreativeImage) => {
    return slide.id === store.activeSlideId ? { ...slide, video: null, image } : slide;
  };

  const carouselsReducer = (acc: CreativeImage[], currentValue: CarouselCreative) => {
    const carouselImages = _.compact(_.map(currentValue.carouselAssetSpecs, 'image'));
    return [...acc, ...carouselImages];
  };

  const images = useMemo(
    () => ({
      aiImages: store.images.filter((image) => image.type === 'AiImage'),
      articleImages: store.images.filter((image) => image.type === 'ArticleImage'),
      marketerImages: store.images.filter((image) => image.type === 'CreativeImage')
    }),
    [store.images]
  );

  return {
    images,
    isSelected,
    handleImageSelect,
    activeImageTab: store.activeImageTab
  };
};
